export default __webpack_public_path__ + "static/media/press-17.2d9d78a1.jpg";